export interface TithiControlInfo {
  hi: string;
  significance: string;
  significanceHi: string;
  auspicious: boolean;
}

export const TITHI_CONTROL_DATA: Readonly<Record<string, TithiControlInfo>> = {
  Pratipada: {
    hi: "प्रतिपदा",
    significance: "Auspicious for new beginnings, business, and travel. Ruled by Agni (Fire).",
    significanceHi:
      "नई शुरुआत, व्यापार और यात्रा के लिए शुभ मानी जाती है। इसके अधिदेवता अग्नि हैं।",
    auspicious: true,
  },
  Dwitiya: {
    hi: "द्वितीया",
    significance: "Good for all auspicious work, marriage, and ceremonies. Ruled by Brahma.",
    significanceHi:
      "शुभ कार्य, विवाह और संस्कारों के लिए अच्छी मानी जाती है। इसके अधिदेवता ब्रह्मा हैं।",
    auspicious: true,
  },
  Tritiya: {
    hi: "तृतीया",
    significance:
      "Favored for work requiring strength and courage. Ruled by Gauri. Hartalika Teej.",
    significanceHi: "बल और साहस वाले कार्यों के लिए अनुकूल मानी जाती है। इसकी अधिदेवी गौरी हैं।",
    auspicious: true,
  },
  Chaturthi: {
    hi: "चतुर्थी",
    significance:
      "Sacred to Lord Ganesha. Avoid new beginnings; ideal for worship and removing obstacles.",
    significanceHi:
      "भगवान गणेश को समर्पित मानी जाती है। नई शुरुआत के बजाय पूजा और बाधा-निवारण से जुड़ी है।",
    auspicious: false,
  },
  Panchami: {
    hi: "पंचमी",
    significance: "Good for learning, medicine, and art. Ruled by the Nagas (serpents).",
    significanceHi: "विद्या, चिकित्सा और कला के लिए अच्छी मानी जाती है। इसके अधिदेवता नाग हैं।",
    auspicious: true,
  },
  Shashthi: {
    hi: "षष्ठी",
    significance: "Favorable for military work and conflict resolution. Ruled by Karttikeya.",
    significanceHi:
      "साहसिक कार्य और विवाद समाधान के लिए अनुकूल मानी जाती है। इसके अधिदेवता कार्तिकेय हैं।",
    auspicious: true,
  },
  Saptami: {
    hi: "सप्तमी",
    significance: "Ruled by Surya (Sun). Good for travel and official work.",
    significanceHi: "इसके अधिदेवता सूर्य हैं। यात्रा और आधिकारिक कार्य के लिए अच्छी मानी जाती है।",
    auspicious: true,
  },
  Ashtami: {
    hi: "अष्टमी",
    significance: "Sacred to Shiva and Durga. Powerful for worship; avoid auspicious ceremonies.",
    significanceHi:
      "शिव और दुर्गा को समर्पित मानी जाती है। पूजा के लिए प्रभावशाली, पर शुभ संस्कारों से बचने की परंपरा है।",
    auspicious: false,
  },
  Navami: {
    hi: "नवमी",
    significance:
      "Ruled by the Pitrs (ancestors). Good for ancestor rites (Shraddha, Pitru Tarpan).",
    significanceHi:
      "पितरों से जुड़ी मानी जाती है। श्राद्ध और पितृ तर्पण जैसे पूर्वज-कर्मों के लिए उपयुक्त है।",
    auspicious: false,
  },
  Dashami: {
    hi: "दशमी",
    significance: "Favorable for all good work. Ruled by Dharmaraja. Vijaya Dashami falls here.",
    significanceHi: "शुभ कार्यों के लिए अनुकूल मानी जाती है। इसके अधिदेवता धर्मराज हैं।",
    auspicious: true,
  },
  Ekadashi: {
    hi: "एकादशी",
    significance:
      "Most sacred fasting tithi. Ruled by Vishnu. Ideal for fasting, prayers, and spiritual practice.",
    significanceHi:
      "उपवास की अत्यंत पवित्र तिथि मानी जाती है। विष्णु पूजा, प्रार्थना और साधना से जुड़ी है।",
    auspicious: true,
  },
  Dwadashi: {
    hi: "द्वादशी",
    significance: "Break of the Ekadashi fast. Auspicious for charity and giving. Ruled by Hari.",
    significanceHi:
      "एकादशी व्रत के पारण, दान और सेवा के लिए शुभ मानी जाती है। इसके अधिदेवता हरि हैं।",
    auspicious: true,
  },
  Trayodashi: {
    hi: "त्रयोदशी",
    significance: "Sacred to Shiva (Pradosh Vrat). Auspicious for spiritual practices and worship.",
    significanceHi:
      "शिव और प्रदोष व्रत से जुड़ी मानी जाती है। पूजा और आध्यात्मिक साधना के लिए शुभ है।",
    auspicious: true,
  },
  Chaturdashi: {
    hi: "चतुर्दशी",
    significance:
      "Ruled by Shiva and Kali. Powerful for Tantric practices; avoid auspicious ceremonies.",
    significanceHi:
      "शिव और काली से जुड़ी मानी जाती है। विशेष साधना के लिए प्रभावशाली, पर शुभ संस्कारों से बचने की परंपरा है।",
    auspicious: false,
  },
  Purnima: {
    hi: "पूर्णिमा",
    significance:
      "Full Moon — most auspicious Poorna tithi. Sacred for Satyanarayan Puja, Holi, Guru Purnima.",
    significanceHi:
      "पूर्ण चंद्र की पूर्णा तिथि मानी जाती है। सत्यनारायण पूजा और गुरु पूर्णिमा जैसे अनुष्ठानों से जुड़ी है।",
    auspicious: true,
  },
  Amavasya: {
    hi: "अमावस्या",
    significance:
      "New Moon — dedicated to ancestors and Pitru worship. Avoid auspicious beginnings; powerful for ancestral rites.",
    significanceHi:
      "अमावस्या पितरों और पितृ पूजा को समर्पित मानी जाती है। शुभ शुरुआत के बजाय पूर्वज-कर्मों से जुड़ी है।",
    auspicious: false,
  },
};
